module.exports = __webpack_public_path__ + "img/guzhiReport5.357d03bf.png";